import React from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import lowPerformerIcon from "../../../assets/star-rating-low-performer.svg";
import highPerformerIcon from "../../../assets/star-rating-high-performer.svg";
import { useTranslate } from "../../../helpers/intlHooks";
import { StarRating } from "../../../components";
import { StarRating as StarRatingType } from "../../../@types";
import { hideStarRatings } from "../../../helpers";

interface OverallStarRatingProps {
  starRating?: StarRatingType;
  highPerforming: boolean;
  lowPerforming: boolean;
  planYear: string;
}

const OverallStarRating: React.FunctionComponent<OverallStarRatingProps> = props => {
  const t = useTranslate();
  const { enableNextPlanYearStarRatings, mctCurrentPlanYear } = useFlags();
  const showStarRatings = !hideStarRatings(props.planYear, {
    enableNextPlanYearStarRatings,
    mctCurrentPlanYear,
  });

  return (
    <>
      {showStarRatings && props.lowPerforming && (
        <div className="StarRatingRow StarRatingRow__performerRow">
          <div className="ds-u-display--flex">
            <img
              src={lowPerformerIcon}
              className="StarRating__performerIcon ds-u-margin-right--1"
              alt={t("plan_stars.alt.low_performer")}
              data-testid="low-performer"
            />
            <span>{t("plan_stars.low_performer")}</span>
          </div>
        </div>
      )}

      {showStarRatings && props.highPerforming && (
        <div className="StarRatingRow StarRatingRow__performerRow">
          <div className="ds-u-display--flex">
            <img
              src={highPerformerIcon}
              className="StarRating__performerIcon ds-u-margin-right--1"
              alt={t("plan_stars.alt.high_performer")}
              data-testid="high-performer"
            />
            <span className="mct-u-align-self--end">
              {t("plan_stars.high_performer")}
            </span>
          </div>
        </div>
      )}
      <div className="StarRatingRow StarRatingRow__blue">
        <div>
          <h3 className="StarRatingsSection__heading">
            {t("plan_stars.overall")}
          </h3>
          {t("plan_stars.overall_basis")}
        </div>
        <StarRating
          includeLabel={false}
          highPerforming={props.highPerforming}
          lowPerforming={false}
          stars={props.starRating}
          planYear={props.planYear}
        />
      </div>
    </>
  );
};

export default OverallStarRating;
